import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { RouterOutlet } from '@angular/router';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-applayout',
  imports: [HeaderComponent, SidebarComponent, RouterOutlet, NgClass],
  templateUrl: './applayout.component.html',
  styleUrls: ['./applayout.component.css']
})
export class ApplayoutComponent implements OnInit {

  @ViewChild(SidebarComponent) sidebarRef!: SidebarComponent; // ← ajout

  collapsed = false;
  isMobile = false;
  isMobileSidebarOpen = false;

  ngOnInit(): void { this.checkMobile(); }

  @HostListener('window:resize')
  onResize(): void { this.checkMobile(); }

  private checkMobile(): void {
    const wasMobile = this.isMobile;
    this.isMobile = window.innerWidth <= 768;
    if (this.isMobile !== wasMobile) {
      this.isMobileSidebarOpen = false;
    }
  }

  toggleSidebar(): void {
    this.isMobile = window.innerWidth <= 768;

    if (this.isMobile) {
      // ← déléguer directement à la sidebar
      this.isMobileSidebarOpen = !this.isMobileSidebarOpen;
      this.isMobileSidebarOpen
        ? this.sidebarRef.openMobile()
        : this.sidebarRef.closeMobile();
    } else {
      this.collapsed = !this.collapsed;
    }
  }

  closeMobileSidebar(): void {
    this.isMobileSidebarOpen = false;
    this.sidebarRef?.closeMobile(); // ← sync
  }

  handleClickOutside(): void {
    if (!this.isMobile) {
      this.isMobileSidebarOpen = false;
    }
  }

  onOneMenuClicked(): void {
    if (this.isMobile) {
      this.isMobileSidebarOpen = false;
      // pas besoin d'appeler closeMobile() : la sidebar le fait déjà dans onClickMenu()
    }
  }
}